const MODERN_SUPPORTED_PATHS = new Set(['', '/', '/factory']);

const MODERN_SUPPORTED_PREFIXES = ['/groups'];

const CLASSIC_PIPELINE_SEGMENTS = new Set(['new']);

export const MODERN_PROJECT_TABS = new Set([
  'versions',
  'devices',
  'pipelines',
  'documents',
  'state-layer',
]);

const normalizePathname = (pathname: string) =>
  pathname.length > 1 && pathname.endsWith('/')
    ? pathname.slice(0, -1)
    : pathname;

const isModernProjectRoute = (pathname: string) => {
  if (pathname !== '/projects' && !pathname.startsWith('/projects/')) {
    return false;
  }

  const [, , , panelTab, ...childSegments] = pathname.split('/');

  if (panelTab === undefined) return true;

  if (panelTab === 'compare') return childSegments.length === 2;

  return MODERN_PROJECT_TABS.has(panelTab) && childSegments.length <= 1;
};

const isModernResourceRoute = (
  root: string,
  pathname: string,
  classicSegments: ReadonlySet<string> = new Set(),
) => {
  if (pathname !== root && !pathname.startsWith(`${root}/`)) return false;

  const [, , segment, ...deeperSegments] = pathname.split('/');

  if (deeperSegments.length > 0) return false;

  return !(segment && classicSegments.has(segment));
};

export const isModernRouteSupported = (pathname: string) => {
  const normalized = normalizePathname(pathname);

  if (MODERN_SUPPORTED_PATHS.has(normalized)) return true;

  if (isModernProjectRoute(normalized)) return true;

  if (isModernResourceRoute('/devices', normalized)) return true;

  if (isModernResourceRoute('/documents', normalized)) return true;

  if (isModernResourceRoute('/gateways', normalized)) return true;

  if (
    isModernResourceRoute('/pipelines', normalized, CLASSIC_PIPELINE_SEGMENTS)
  ) {
    return true;
  }

  return MODERN_SUPPORTED_PREFIXES.some(
    (prefix) => normalized === prefix || normalized.startsWith(`${prefix}/`),
  );
};
